import { createFileRoute } from "@tanstack/react-router";
import { SettingsMembersPage } from "@/pages/settingsLayout";

export const Route = createFileRoute("/_app/settings/members")({
  component: SettingsMembersPage
});
